import { EventEmitter } from "./EventEmitter.js";

/**
 * Automatically reconnecting websocket
 */
export class BetterWebsocket extends EventEmitter {

    constructor(url) {
        super();
        this.url = url;
        this._forceClose = false;
        this._backoff = 5;
        this._ws = null;
        this.open();
    }

    setURL(url){
        this.url = url;
        this.open();
    }

    open() {
        this._forceClose = false;
        if(this.url == null){
            return;
        }
        let ws = new WebSocket(this.url);
        ws.addEventListener("message", this.emit.bind(this, "message"));
        ws.addEventListener("open", this.emit.bind(this, "open"));
        ws.addEventListener("error", this.emit.bind(this, "error"));
        ws.addEventListener("close", (ev) => {
            console.log("Closed with code", ev.wasClean, ev.code, ev.reason);
            if (!this._forceClose) {
                this.emit("reconnect", ev);
                setTimeout(() =>{
                    this.open();
                }, this._backoff * 1000);
                
            }else{
                this.emit("close", ev);
            }
        });
        this._ws = ws;
    }

    send(msg){
        this._ws.send(msg);
    }
    
    
    close(){
        this._forceClose = true;
        this._ws.close();
    }
}